import api from './api';

class ShippingService {
    async getRegions() {
        return api.get('orders/shipping-regions/');
    }
}

export default new ShippingService();
